<res-base-modal [modalTitle]="'Word List'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [isPrimaryButtonHidden]="true" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="'Close'"
    [(isBusy)]="isBusyWordlist" [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex">

    <res-left-right-selection-box [useDragAndDrop]="false" [automationId]="modalAutomationId" leftListSize="55.5"
        [itemsLeft]="itemsLeft" [itemsRight]="itemsRight" leftListTitle="Available Words"
        [leftListGridContext]="leftListGridContext" [rightListGridContext]="rightListGridContext"
        rightListTitle="Words to Search" [leftListTemplate]="leftGridHeaderTemplate"
        [leftListPagerName]="'list (and deselect all rows)'" [leftListPagerTemplate]="pagerTemplate"
        [leftListRequestInfo]="wordListRequestInfo" [leftListResponseArrayCallback]="responseArrayCallback"
        [leftListResponseCallback]="responseCallback" [leftListColumns]="leftListColumns"
        [rightListColumns]="rightListColumns" [leftListPagerVisible]="'true'"
        [rightListBottomTemplate]="searchBarTemplate" [sortItemsLeft]="true" [sortItemsRight]="true"
        (customMoveItems)="copyOrRemoveItems($event)">
    </res-left-right-selection-box>

    <ng-template #leftGridHeaderTemplate>
        <span class="selected-items">Selected: <span>{{leftListSelectedItems()}}</span></span>
    </ng-template>
    <ng-template #pagerTemplate>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-download-button'"
            *ngIf="hasDocReportsPermission" class="secondary-button icon-button" (click)="downloadWordList()"
            title="Download or Save the Filtered List(.csv) ...">
            <i class="fa fa-download color-blue-01"></i>
        </button>
    </ng-template>
    <ng-template #searchBarTemplate>
        <res-collapsible-toggle-box-group [toggleItems]="searchToggles" [data-automation-id]="modalAutomationId">
        </res-collapsible-toggle-box-group>
        <div class="search-bar">
            <button type="button" class="primary-button search-button" (click)="search()"
                [disabled]="isSearchDisabled()"
                [title]="isSearchDisabled() ? 'To search add at least one word on the word to search side and select search target.': ''"
                [attr.data-automation-id]="modalAutomationId + '-search-button'">Search</button>
            <span>in</span>
            <div class="target-picker">
                <input type="text" title="{{searchTarget.name}}" readonly [ngModel]="searchTarget.name"
                    [attr.data-automation-id]="modalAutomationId + '-search-target-input'">
                <i class="fa fa-filter filter-indicator" [title]="corporaFilterTooltip"
                    *ngIf="corporaFilters && corporaFilters.length > 0"
                    [attr.data-automation-id]="modalAutomationId + '-data-sets-filter-indicator'"></i>
                <button type="button" class="primary-button target-button" (click)="onTargetSelect()"
                    [attr.data-automation-id]="modalAutomationId + '-search-target-button'"><i
                        class="fa fa-crosshairs"></i>Select Target ...
                </button>
            </div>
        </div>
    </ng-template>
</res-base-modal>